import logo from './logo.png'
import experienceApplicationImport from './experience-application-import.png'
import experienceApplicationBtn from './experience-application-btn.png'
import bgIcon0 from './bg-icon0.png'
import bgIcon1 from './bg-icon1.png'
import bgIcon2 from './bg-icon2.png'
let bgIconList = [
    bgIcon0,
    bgIcon1,
    bgIcon2
]
export {
    logo as logo,
    experienceApplicationImport as experienceApplicationImport,
    experienceApplicationBtn as btn,
    bgIconList as bgIconList
}